module.exports = "./img/716de05a4a0482afbe3e261e69492a78.jpg";